import { useNavigate, useSearchParams } from "react-router-dom"

import type { OnboardingStep as PageBuilderOnboardingStep } from "../../onboarding/OnboardingSteps"

export function useSharedOnboardingParams() {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()

  function setStepParam(step: PageBuilderOnboardingStep) {
    searchParams.set("onboardingStep", step)
    setSearchParams(searchParams)
  }

  function deleteStepParam() {
    if (searchParams.get("onboardingStep")) {
      searchParams.delete("onboardingStep")
      setSearchParams(searchParams)
    }
  }

  function navigateWithStepParam(
    pathname: string,
    step: PageBuilderOnboardingStep
  ) {
    navigate({ pathname, search: `?onboardingStep=${step}` }, { replace: true })
  }

  return {
    onboardingStep: searchParams.get("onboardingStep"),
    searchParams,
    setStepParam,
    deleteStepParam,
    navigateWithStepParam
  }
}
